/*
 * File: components.js
 * Project: <<marketing-system>>
 * File Created: 2018-8-21 11:51:4 AM
 * Author: xiongyang (yang.xiong@meicloud.com)
 * -----
 * Last Modified: 2018-05-30 11:37:21 am
 * Modified By: xiongyang (yang.xiong@meicloud.com>) (<<git>>)
 * -----
 * Copyright © 2018 - MeiCloud, MeiCloud
 */

/** 集中加载页面组件（懒加载方式） */
/** 通用页面组件 */
/* eslint-disable */
// 一级布局
export const Layout = () => import('@/views/Layout');
// 首页专用布局页面
export const HomeLayout = () => import('@/views/Layout/HomeLayout');

// 头部区（logo、一级菜单）
export const NavHeader = () => import('@/views/Layout/NavHeader');
// 二级菜单
export const SecondMenu = () => import('@/views/Layout/SecondMenu');
// 页面标题
export const BodyHeader = () => import('@/views/Layout/BodyHeader');
// 详情页，三级内页
export const DetailLayout = () => import('@/views/Layout/DetailLayout');

// 登录
export const Login = () => import('@/views/loginNew');
// 入口页面
export const Entrance = () => import('@/views/entrancePage');
// 错误页面
export const ErrorPage = () => import('@/views/ErrorPage');
// 主页
export const Home = () => import('@/views/home');

/** 专有页面组件 */

/** -------------------- 会员管理 ---------------------- */
// 会员列表
export const MemberListIndex = () => import('@/views/MemberManagement/MemberList/List');
// 会员详情
export const MemberListDetail = () => import('@/views/MemberManagement/MemberList/MemberDetail');
// 导出记录
export const MemberExportRecord = () => import('@/views/MemberManagement/MemberList/ExportRecord');

// 等级规则
export const MemberLevelRule = () => import('@/views/MemberManagement/MemberLevel/RuleList');
// 新增等级规则
export const MemberLevelRightAdd = () => import('@/views/MemberManagement/MemberLevel/AddLevel');
// 商品编码
export const CommodityCode = () => import('@/views/MemberManagement/MemberLevel/CommodityCode');

// 成长规则
export const MemberGrowthRule = () => import('@/views/MemberManagement/GrowthManagement/GrowRule');
// 成长值流水
export const MemberGrowthList = () => import('@/views/MemberManagement/GrowthManagement/GrowList');
// 成长值修改
export const MemberGrowthEdit = () => import('@/views/MemberManagement/GrowthManagement/GrowEdit');
// 添加成长值规则
export const MemberGrowthRuleCreate = () => import('@/views/MemberManagement/GrowthManagement/GrowRule/CreateRule');

/** 积分管理 */
// 积分规则
export const IntegralRule = () => import('@/views/MemberManagement/IntegralManagement/IntegralRule');
// 新增积分规则
export const AddIntegralRule = () => import('@/views/MemberManagement/IntegralManagement/AddIntegralRule');
// 积分流水
export const IntegralStream = () => import('@/views/MemberManagement/IntegralManagement/IntegralStream');
// 积分修改
export const IntegralEdit = () => import('@/views/MemberManagement/IntegralManagement/IntegralEdit');
// 额外积分规则
export const ExtraIntegralRule = () => import('@/views/MemberManagement/IntegralManagement/ExtraIntegralRule');
// 新增额外积分规则
export const AddExtraIntegralRule = () => import('@/views/MemberManagement/IntegralManagement/ExtraIntegralRule/AddRule');

/** 积分池管理 */
// 积分池列表
export const IntegralPoolList = () => import('@/views/MemberManagement/IntegralPool/List');
// 积分池预警
export const IntegralPoolWarning = () => import('@/views/MemberManagement/IntegralPool/Warning');
// 积分池审核
export const IntegralPoolExamine = () => import('@/views/MemberManagement/IntegralPool/Examine');
// 积分池流水
export const IntegralPoolStream = () => import('@/views/MemberManagement/IntegralPool/Stream');
// 积分采购管理
export const IntegralPurchase = () => import('@/views/MemberManagement/IntegralPool/Purchase');

/** 黑名单管理 */
// 黑名单列表
export const BlackList = () => import('@/views/MemberManagement/BlackList');
// 新增黑名单
export const AddBlackList = () => import('@/views/MemberManagement/BlackList/AddBlackList');

/** -------------------- 系统设置 ---------------------- */
// 渠道设置
export const ChannelSetting = () => import('@/views/SystemSetup/ChannelSetting');
// 添加渠道
export const ChannelCreate = () => import('@/views/SystemSetup/ChannelSetting/CreatChannel');
// 字典配置
export const DictConfig = () => import('@/views/SystemSetup/DictConfig');
// 快速通道
export const FastChannel = () => import('@/views/SystemSetup/FastChannel');
// 操作日志
export const OperationLog = () => import('@/views/SystemSetup/OperationLog');
// 店铺管理
export const StoreMgr = () => import('@/views/SystemSetup/StoreMgr');
// 新增店铺
export const AddStoreMgr = () => import('@/views/SystemSetup/StoreMgr/AddStoreMgr');
// 账号管理
export const AccountManagement = () => import('@/views/SystemSetup/AccountManagement');
// 账号新增
export const AccountManagementAdd = () => import('@/views/SystemSetup/AccountManagement/SystemAccount/Add');
// 账号详情
export const AccountManagementDetail = () => import('@/views/SystemSetup/AccountManagement/SystemAccount/Detail');
// 角色管理
export const RoleManagement = () => import('@/views/SystemSetup/RoleManagement');
// 新增角色
export const RoleManagementAdd = () => import('@/views/SystemSetup/RoleManagement/Add');
// 角色用户
export const RoleManagementUser = () => import('@/views/SystemSetup/RoleManagement/ViewUsers');
// 字典数据
export const DictionaryData = () => import('@/views/SystemSetup/DictionaryData');
// 菜单功能
export const MenuManagement = () => import('@/views/SystemSetup/MenuManagement');

// 主体列表
export const OrgMgrList = () => import('@/views/SystemSetup/OrgMgr/OrgList');
// 添加/修改主体
export const AddOrg = () => import('@/views/SystemSetup/OrgMgr/AddOrg');

// 礼品管理
export const GiftManagementList = () => import('@/views/SystemSetup/GiftManagement');
// 新建礼品
export const GiftAdd = () => import('@/views/SystemSetup/GiftManagement/Add');
// 礼品详情
export const GiftDetail = () => import('@/views/SystemSetup/GiftManagement/Detail');

// 积分规则调用方
export const IntegralRuleCaller = () => import('@/views/SystemSetup/IntegralRuleCaller');
// 修改手机号
export const ModifyMobile = () => import('@/views/SystemSetup/ModifyMobile');

// 敏感词管理
export const SensitiveWordsMgr = () => import('@/views/SystemSetup/SensitiveWordsMgr');

/** -------------------- 数据看板 ---------------------- */
/** 其它报表 */
/** 积分统计 */
// 积分消耗
export const IntegralConsume = () => import('@/views/DataKanban/OtherReports/IntegralStatistics/IntegralConsume');
// 积分日报
export const IntegralDaily = () => import('@/views/DataKanban/OtherReports/IntegralStatistics/IntegralDaily');
// 积分发放
export const IntegralGrant = () => import('@/views/DataKanban/OtherReports/IntegralStatistics/IntegralGrant');
// 事业部对账日报
export const IntegralOrgAccounts = () => import('@/views/DataKanban/OtherReports/IntegralStatistics/OrgAccounts');
// 任务看板
export const TaskKanban = () => import('@/views/DataKanban/OtherReports/TaskAnalysis/TaskKanban');

/** 勋章数据统计 */ 
// 勋章日报
export const MedalDaily = () => import('@/views/DataKanban/MedalStatistics/MedalDaily');


/** 数据分析 */
// 会员分析
export const MemberAnalysis = () => import('@/views/DataKanban/MemberAnalysis');
// 会员分析明细
export const MemberAnalysisDetail = () => import('@/views/DataKanban/MemberAnalysis/Detail');
// 来源分析
export const SourceAnalysis = () => import('@/views/DataKanban/SourceAnalysis');
// 会员等级分析
export const MembershipGrade = () => import('@/views/DataKanban/RightsAnalysis/MembershipGrade');
// 会员积分分析
export const MembershipIntegral = () => import('@/views/DataKanban/RightsAnalysis/MembershipIntegral');
// 留存分析
export const RetainAnalysis = () => import('@/views/DataKanban/RetainAnalysis');
// 销售分析
export const SaleAnalysis = () => import('@/views/DataKanban/SaleAnalysis');
// 会员积分分析 - 明细
export const MembershipIntegralDetail = () => import('@/views/DataKanban/RightsAnalysis/MembershipIntegral/Detail');
// 会员等级分析 - 明细
export const MembershipGradeDetail = () => import('@/views/DataKanban/RightsAnalysis/MembershipGrade/Detail');
// 来源分析 - 明细
export const SourceAnalysisDetail = () => import('@/views/DataKanban/SourceAnalysis/Detail');

/** -------------------- 营销中心 ---------------------- */
/** 积分兑换 */
// 积分兑换列表
export const IntegralExchangeList = () => import('@/views/MarketingMgr/IntegralExchange/List');
// 新建兑换商品
export const IntegralExchangeAdd = () => import('@/views/MarketingMgr/IntegralExchange/Add');
// 兑换商品详情
export const IntegralExchangeDetail = () => import('@/views/MarketingMgr/IntegralExchange/Detail');
// 订单管理
export const OrderList = () => import('@/views/MarketingMgr/IntegralExchange/OrderList');
// 订单详情
export const OrderListDetail = () => import('@/views/MarketingMgr/IntegralExchange/OrderList/Detail');
// 商城积分管理
export const IntegralMall = () => import('@/views/MarketingMgr/IntegralExchange/IntegralMall');

/** 优惠券管理 */
// 优惠券规则列表
export const CouponRuleList = () => import('@/views/MarketingMgr/CouponMgr/RuleList');
// 新建优惠券规则
export const CouponRuleAdd = () => import('@/views/MarketingMgr/CouponMgr/RuleList/Add');
// 优惠券规则详情
export const CouponRuleDetail = () => import('@/views/MarketingMgr/CouponMgr/RuleList/Detail');
// 手动领取列表
export const CouponManualList = () => import('@/views/MarketingMgr/CouponMgr/ManualList');
// 新建手动领取
export const CouponManualAdd = () => import('@/views/MarketingMgr/CouponMgr/ManualList/Add');
// 手动领取详情
export const CouponManualDetail = () => import('@/views/MarketingMgr/CouponMgr/ManualList/Detail');
// 自动发放列表
export const CouponAutoList = () => import('@/views/MarketingMgr/CouponMgr/AutoList');
// 新建自动发放
export const CouponAutoAdd = () => import('@/views/MarketingMgr/CouponMgr/AutoList/Add');
// 自动发放详情
export const CouponAutoDetail = () => import('@/views/MarketingMgr/CouponMgr/AutoList/Detail');
// 优惠券流水
export const CouponOrderList = () => import('@/views/MarketingMgr/CouponMgr/OrderList');
// 优惠券流水详情
export const CouponOrderDetail = () => import('@/views/MarketingMgr/CouponMgr/OrderList/Detail');

/** 广告投放 */
// 广告管理
export const AdList = () => import('@/views/MarketingMgr/AdManagement/List'); // 已弃用
export const AdList1 = () => import('@/views/MarketingMgr/advManagementNew/List');
// 广告详情
export const AdDetail = () => import('@/views/MarketingMgr/AdManagement/Detail');
export const adKanban = () => import('@/views/MarketingMgr/advManagementNew/Detail');

/** 短链管理 */
// 短链列表
export const ShortChainList = () => import('@/views/MarketingMgr/ShortChain/List');
// 短链新增编辑
export const ShortChainAdd = () => import('@/views/MarketingMgr/ShortChain/Add');
// 短链详情
export const ShortChainDetail = () => import('@/views/MarketingMgr/ShortChain/Detail');

/** 短信管理 */
// 短信管理列表
export const SmsManagementList = () => import('@/views/MarketingMgr/SmsManagement/List');
// 新增批量短信
export const SmsAddBatch = () => import('@/views/MarketingMgr/SmsManagement/AddBatch');
// 新增点对点短信
export const SmsAddPoint = () => import('@/views/MarketingMgr/SmsManagement/AddPoint');
// 详情
export const SmsDetail = () => import('@/views/MarketingMgr/SmsManagement/Detail');

/** 短信模板 */
// 短信模板列表
export const SmsTemplateList = () => import('@/views/MarketingMgr/SmsManagement/TemplateList');
// 新增短信模板
export const SmsAddTemplate = () => import('@/views/MarketingMgr/SmsManagement/AddTemplate');
// 模板详情
export const SmsTemplateDetail = () => import('@/views/MarketingMgr/SmsManagement/TemplateDetail');

/** 消息中心 */
// 消息列表
export const MsgManagementList = () => import('@/views/MarketingMgr/MsgManagement/List');
// 新增消息
export const MsgCreate = () => import('@/views/MarketingMgr/MsgManagement/Create');
// 消息详情
export const MsgDetail = () => import('@/views/MarketingMgr/MsgManagement/Detail');

/** 推送管理 */
// 推送列表
export const pushManage = () => import('@/views/MarketingMgr/operationManagement/pushManagement/List');
// 新增推送
export const pushManageAdd = () => import('@/views/MarketingMgr/operationManagement/pushManagement/Add');
// 编辑推送
export const pushManageEdit = () => import('@/views/MarketingMgr/operationManagement/pushManagement/Edit');
// 推送详情
export const pushManageDetail = () => import('@/views/MarketingMgr/operationManagement/pushManagement/Detail');

/** 推送分析 */
export const pushAnalysis = () => import('@/views/MarketingMgr/operationManagement/pushAnalysis');

/** 广告管理 */
// 广告列表
export const advertisementManage = () => import('@/views/MarketingMgr/operationManagement/advertisementManagement/List');
// 新增广告
export const advAdd = () => import('@/views/MarketingMgr/operationManagement/advertisementManagement/Add');
// 编辑广告
export const advEdit = () => import('@/views/MarketingMgr/operationManagement/advertisementManagement/Edit');
// 广告详情
export const advDetail = () => import('@/views/MarketingMgr/operationManagement/advertisementManagement/Detail');

// 广告分析
export const advertisementAnalysis = () => import('@/views/MarketingMgr/operationManagement/advertisementAnalysis');

/** 广告位管理 */
// 广告位列表
export const advPosManage = () => import('@/views/MarketingMgr/operationManagement/advPosManagement/List');
// 新增广告位
export const advPosAdd = () => import('@/views/MarketingMgr/operationManagement/advPosManagement/Add');
// 编辑广告位
export const advPosEdit = () => import('@/views/MarketingMgr/operationManagement/advPosManagement/Edit');

/** 页面管理 */
// 页面列表
export const pageManage = () => import('@/views/MarketingMgr/operationManagement/pageManagement/List');
// 新增页面
export const pageAdd = () => import('@/views/MarketingMgr/operationManagement/pageManagement/Add');
// 查看页面
export const pageDetail = () => import('@/views/MarketingMgr/operationManagement/pageManagement/Detail');

// 页面分析
export const pageAnalysis = () => import('@/views/MarketingMgr/operationManagement/pageAnalysis');

/** 活动中心 */
// 签名活动列表
export const SignList = () => import('@/views/MarketingMgr/ActivityCenter/Sign/List');
// 新增签名活动
export const SignAdd = () => import('@/views/MarketingMgr/ActivityCenter/Sign/Add');

/** 新品试用 */
// 新品试用列表
export const TrialList = () => import('@/views/MarketingMgr/TrialOfNewProducts/TrialList');
// 新增新品试用
export const TrialAdd = () => import('@/views/MarketingMgr/TrialOfNewProducts/Add');
// 试用详情页
export const TrialDetail = () => import('@/views/MarketingMgr/TrialOfNewProducts/Detail');
// 用户使用列表
export const UserTrialList = () => import('@/views/MarketingMgr/TrialOfNewProducts/UserTrialList');
// 编辑评测内容
export const EditEvaluate = () => import('@/views/MarketingMgr/TrialOfNewProducts/EditEvaluate');
// 评测内容列表
export const EvaluationList = () => import('@/views/MarketingMgr/TrialOfNewProducts/EvaluationList');
// 评测内容详情
export const EvaluationDetail = () => import('@/views/MarketingMgr/TrialOfNewProducts/EvaluationList/Detail');

/** 微信模板消息 */
// 模板消息列表
export const WechatTemplateMsg = () => import('@/views/MarketingMgr/WechatTemplateMsg');

/** 受众人群管理 */
// 受众人群列表
export const AudienceCrowdList = () => import('@/views/MarketingMgr/AudienceCrowd/List');
// 新建人群
export const AudienceCrowdAdd = () => import('@/views/MarketingMgr/AudienceCrowd/Add');
// 人群详情
export const AudienceCrowdDetail = () => import('@/views/MarketingMgr/AudienceCrowd/Detail');
// 引用大数据人群 
export const AudienceUseBigData = () => import('@/views/MarketingMgr/AudienceCrowd/UseBigData');
// 大数据人群包详情
export const AudienceUseBigDataDetail = () => import('@/views/MarketingMgr/AudienceCrowd/UseBigData/Detail');

/** 精准投放管理 */
// 受众人群列表
export const DeliveryManagementList = () => import('@/views/MarketingMgr/DeliveryManagement/List');
// 受众人群列表 - 日历模式
export const DeliveryManagementCalendar = () => import('@/views/MarketingMgr/DeliveryManagement/Calendar');
// 新增投放
export const DeliveryManagementAdd = () => import('@/views/MarketingMgr/DeliveryManagement/Add');
// 投放任务创建成功
export const DeliveryManagementSuccess = () => import('@/views/MarketingMgr/DeliveryManagement/Success');
// 投放详情
export const DeliveryManagementDetail = () => import('@/views/MarketingMgr/DeliveryManagement/Detail');

/** 自动化营销策略 */
// 自动化营销策略列表
export const AutomationStrategyList = () => import('@/views/MarketingMgr/AutomationStrategy/List');
// 新增编辑自动化营销策略
export const AutomationStrategyAdd = () => import('@/views/MarketingMgr/AutomationStrategy/Add');
// 自动化营销策略详情
export const AutomationStrategyDetail = () => import('@/views/MarketingMgr/AutomationStrategy/Detail');
// 自动化营销策略 - 查看数据
export const AutomationStrategyViewData = () => import('@/views/MarketingMgr/AutomationStrategy/ViewData');

/** 效果报表总览管理 */
// 效果报表总览
export const EffectivenessReportOverview = () => import('@/views/MarketingMgr/EffectivenessReport/Overview');
// 效果报表详情
export const EffectivenessReportDetail = () => import('@/views/MarketingMgr/EffectivenessReport/Detail');

/** 图文专题 */
// 图文专题列表
export const MaterialList = () => import('@/views/MarketingMgr/MaterialManagement/List');
// 新增图文素材
export const MaterialAdd = () => import('@/views/MarketingMgr/MaterialManagement/Add');
// 图文效果
export const MaterialDetail = () => import('@/views/MarketingMgr/MaterialManagement/Detail');

/** 内容管理 */
// 内容管理列表
export const ContentList = () => import('@/views/MarketingMgr/ContentManagement/List');
// 内容管理详情
export const ContentAdd = () => import('@/views/MarketingMgr/ContentManagement/Add');
// 内容管理效果
export const ContentDetail = () => import('@/views/MarketingMgr/ContentManagement/Detail');


/** -------------------- 潜在用户 ---------------------- */
// 会员列表
export const PotentialMemberListIndex = () => import('@/views/PotentialMember/MemberList/List');
// 会员详情
export const PotentialMemberListDetail = () => import('@/views/PotentialMember/MemberList/MemberDetail');


/** -------------------- 社交管理 ---------------------- */
// 账号管理
export const AccountManagementListIndex = () => import('@/views/MarketingMgr/SocialContact/AccountManagement/List');
// 动态管理-动态详情
export const AccountDetail = () => import('@/views/MarketingMgr/SocialContact/AccountManagement/Detail');
// 举报管理
export const AccusationManagementListIndex = () => import('@/views/MarketingMgr/SocialContact/AccusationManagement/List');
// 账号举报详情
export const AccountAccusationDetail = () => import('@/views/MarketingMgr/SocialContact/AccusationManagement/Detail/AccountAccusationDetail.vue');
// 账号举报详情
export const DynamicAccusationDetail = () => import('@/views/MarketingMgr/SocialContact/AccusationManagement/Detail/DynamicAccusationDetail.vue');
// 账号申诉详情
export const AccountAppealDetail = () => import('@/views/MarketingMgr/SocialContact/AccusationManagement/Detail/AccountAppealDetail.vue');
//内容申诉详情
export const ContentAppealDetail = () => import('@/views/MarketingMgr/SocialContact/AccusationManagement/Detail/ContentAppealDetail.vue');
// 动态管理
export const DynamicManagement = () => import('@/views/MarketingMgr/SocialContact/DynamicManagement/List');
// 动态管理-动态详情
export const DynamicDetail = () => import('@/views/MarketingMgr/SocialContact/DynamicManagement/Detail');
// 动态管理-发布动态
export const AddDynamic = () => import('@/views/MarketingMgr/SocialContact/DynamicManagement/Add');
// 达人后台
export const TalentManagement = () => import('@/views/MarketingMgr/SocialContact/TalentManagement/List');
// 达人后台-动态详情
export const TalentDetail = () => import('@/views/MarketingMgr/SocialContact/TalentManagement/Detail');
// 达人后台-发布动态
export const AddTalent = () => import('@/views/MarketingMgr/SocialContact/TalentManagement/Add');
// 标签管理
export const LabelManagement = () => import('@/views/MarketingMgr/SocialContact/LabelManagement/List');
// 话题管理
export const TopicManagement = () => import('@/views/MarketingMgr/SocialContact/TopicManagement/List');

/** -------------------- 勋章管理 ---------------------- */
// 勋章规则
export const MedalManagement = () => import('@/views/MemberManagement/MedalManagement/RuleList');
// 新增编辑勋章
export const MedalManagementAdd = () => import('@/views/MemberManagement/MedalManagement/AddMedal');

/** -------------------- 任务中心 ---------------------- */
// 任务中心列表
export const TaskList = () => import('@/views/MemberManagement/TaskCenter/TaskList');
// 新增任务
export const TaskListAdd = () => import('@/views/MemberManagement/TaskCenter/TaskList/add');
// 任务池管理
export const TaskPool = () => import('@/views/MemberManagement/TaskCenter/TaskPool');
